import React, { useEffect, useState } from "react";
// style
import "../../Assets/style/components/login.scss";
import "../../Assets/style/library/animate_css/animate.min.css";
// images
import logo from "../../Assets/images/logo/Inaipi_Logo.png";
import rightmainimg from "../../Assets/images/login/women-with-ipad.png";
import img1 from "../../Assets/images/login/videocall.png";
import img2 from "../../Assets/images/login/Instagram.png";
import img3 from "../../Assets/images/login/chatbot.png";
import img4 from "../../Assets/images/login/SMS2.png";
import img5 from "../../Assets/images/login/Whatsapp.png";
import img6 from "../../Assets/images/login/call.png";
import img7 from "../../Assets/images/login/Facebook.png";

// mui
import {
  CircularProgress,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  FormControl,
  OutlinedInput,
  Box,
  Typography,
  Stack,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Backdrop,
} from "@mui/material";

// icon
import { FiEyeOff } from "react-icons/fi";
import { FiEye } from "react-icons/fi";
import { MdErrorOutline } from "react-icons/md";
// other
import { ToastContainer, toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Input as BaseInput } from "@mui/base/Input";
import { Link } from "react-router-dom";
import {
  setsidebarVal,
  setReadyButton,
  setShowingStatus,
  setShowingStatusVoice,
  setShowingStatusClass,
  setVoicePlatForm,
  setWebRTC,
} from "../../Redux/Actions/actions";
import axios from "axios";
import { toaststyle } from "../../Utils/toaststyle";
const Input = React.forwardRef(function CustomInput(props, ref) {
  const { slots, ...other } = props;
  return (
    <BaseInput
      slots={{
        root: InputRoot,
        input: InputElement,
        ...slots,
      }}
      {...other}
      ref={ref}
    />
  );
});
Input.propTypes = {
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType,
    textarea: PropTypes.elementType,
  }),
};
const mapStateToProps = (state) => {
  const { data } = state;
  return {
    internalchatnotify: data.internalchatnotify,
    selectedmobile: data.selectedmobile,
    selectedemail: data.selectedemail,
    selectedusername: data.selectedusername,
    chatType: data.chatType,
  };
};

const Login = (props) => {
  const navigate = useNavigate();
  const [showloginPage, setshowloginPage] = useState(true);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [emailval, setEmailval] = useState(false);
  const [passval, setPassval] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [userid, setuserid] = useState("");
  const [showPassword, setshowPassword] = useState(true);
  const [logoutModalDialog, setlogoutModalDialog] = useState(false);
  useEffect(() => {
    const tenantID = new URLSearchParams(window.location.search).get(
      "tenantID"
    );
    const frontendBaseURL = window.location.origin + window.location.pathname;
    //localStorage.setItem("TenantId", tenantID);
    localStorage.setItem("frontendBaseURL", frontendBaseURL);
    localStorage.setItem("TenantId", tenantID);
    const username = new URLSearchParams(window.location.search).get(
      "username"
    );
    if (
      username == "MArteta@gmail.com" ||
      username == "supervisorcisco@gmail.com"
    ) {
      setshowloginPage(false);
      setTimeout(() => {
        onSubmit("autoSignIn", username, "Avaya@123");
      }, 2000);
    }
  }, []);
  const logout = async () => {
    axios
      .post(
        BaseUrl + `/users/logout/${userid}`,
        {
          type: "forcelogout",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setlogoutModalDialog(false);
          localStorage.clear();
          window.location.reload();
        } else {
          setlogoutModalDialog(false);
          localStorage.clear();
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log("LogoutAgent", err);
      });
  };
  const onSubmit = async (signIn, username, password) => {
    if (signIn == "autoSignIn") {
    } else {
      if (!email && !pass) {
        // console.log("hello how are you");
        setEmailval(true);
        setPassval(true);
        return;
      } else if (!email) {
        setEmailval(true);
        setPassval(false);
        return;
      } else if (!pass) {
        setEmailval(false);
        setPassval(true);
        return;
      } else {
        setEmailval(false);
        setPassval(false);
      }
    }
    setSpinner(true);
    await axios
      .post(
        BaseUrl + "/users/login",
        {
          email: signIn == "autoSignIn" ? username : email.trim(),
          pass: signIn == "autoSignIn" ? password : pass.trim(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((datas) => {
        if (datas.data.status === true) {
          props.setReadyButton(false);
          props.setShowingStatus("Connected");
          props.setShowingStatusVoice("Connected");
          localStorage.setItem("AgentStatus", "Connected");
          props.setShowingStatusClass("showStatusConnected");
          props.setsidebarVal("Dashboard");
          localStorage.setItem("callList", JSON.stringify([]));
          localStorage.setItem("callCutByAgent", "false");
          localStorage.setItem("access_token", datas.data.access_token_cognicx);

          localStorage.setItem("AvcUrl", datas.data.user.voiceRecord.voiceyt);
          localStorage.setItem("tokenAgent", JSON.stringify(datas.data.user));
          props.setVoicePlatForm(datas.data.user.voiceRecord.voiceType);
          localStorage.setItem(
            "AvayaUsername",
            datas.data.user.voiceRecord.avayaUserName
          );
          if (datas.data.user.voiceagent) {
            localStorage.setItem("AvayaPassword", pass);
          } else {
            localStorage.setItem(
              "AvayaPassword",
              datas.data.user.voiceRecord.avayaPassword
            );
          }
          // localStorage.setItem(
          //   "AvayaPassword",
          //   datas.data.user.voiceRecord.avayaPassword
          // );
          localStorage.setItem(
            "AvayaDomain",
            datas.data.user.voiceRecord.avayaDomain
          );
          localStorage.setItem(
            "permission",
            JSON.stringify(datas.data.user.moduleScreen)
          );
          datas.data.user.moduleScreen.map(async (module) => {
            if (module.moduleName === "Crm") {
              const crmScreen = module.screen.find(
                (item) => item.screenId === "CONTACT" && item.read && item.write
              );

              if (crmScreen) {
                await axios
                  .post(
                    BaseUrl + "/ticket/ticketlogin",
                    { email: datas.data.user.email },
                    {
                      headers: {
                        Authorization:
                          "Bearer " + datas.data.access_token_cognicx,
                        "Content-Type": "application/json",
                        tenantId: localStorage.getItem("TenantId"),
                      },
                    }
                  )
                  .then((res) => {
                    if (res.data.status) {
                      localStorage.setItem(
                        "ticketcrm",
                        JSON.stringify(res.data)
                      );
                    }
                  });
              }
            }
          });
          setTimeout(() => {
            const permissionStr = localStorage.getItem("permission");
            const permission = JSON.parse(permissionStr);
            if (
              permission.find((element) => element.moduleName === "Dashboard")
            ) {
              navigate("/main/Dashboard");
            } else if (
              permission.find((element) => element.moduleName === "Chat")
            ) {
              navigate("/main/Chat");
            } else if (
              permission.find((element) => element.moduleName === "Report")
            ) {
              navigate("/main/SessioReports");
            } else if (
              permission.find((element) => element.moduleName === "Calender")
            ) {
              navigate("/main/Calenders");
            } else {
              navigate("/main/Dashboard");
            }
            setSpinner(false);
          }, 1000);
        } else {
          if (datas.data.user_id != undefined) {
            setSpinner(false);
            setlogoutModalDialog(true);
            setuserid(datas.data.user_id);
          } else {
            setSpinner(false);
            toast.error(datas.data.message, toaststyle);
          }
        }
      })
      .catch((err) => {
        console.log("login", err);
      });
  };
  const handleKeyPress = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      onSubmit();
    }
  };
  const LogoutDialogClose = () => {
    setlogoutModalDialog(false);
  };
  const handleClickShowPassword = () => {
    setshowPassword(!showPassword);
  };

  return (
    <>
      <ToastContainer transition={Flip} limit={2} />
      {showloginPage && (
        <div>
          {/* New login page start here  */}
          <Box className="LoginMain">
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                className="LeftMain animate__animated animate__fadeIn "
              >
                <Grid
                  className="LeftMainSub"
                  container
                  direction="row"
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Grid item md={2} className="LeftVertical">
                    <Stack
                      className="quoteMain"
                      direction="column"
                      spacing={0}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box className="animate__animated animate__fadeInUp  animate__delay-5s">
                        <h3 className="quote_3">Collaborate</h3>
                      </Box>
                      <Box className="quoteSquar animate__animated animate__fadeInUp  animate__delay-4s"></Box>
                      <Box className="animate__animated animate__fadeInUp  animate__delay-3s">
                        <h3 className="quote_2">Converse</h3>
                      </Box>
                      <Box className="quoteSquar animate__animated animate__fadeInUp  animate__delay-2s"></Box>
                      <Box className="animate__animated animate__fadeInUp  animate__delay-1s">
                        <h3 className="quote_1">Connect</h3>
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    md={10}
                    sm={12}
                    className="LoginContent animate__animated animate__fadeIn"
                  >
                    <Box>
                      <Box className="animate__animated animate__fadeInUp animate__slow">
                        <img src={logo} alt="Inaipi_Logo" title="Inaipi_Logo" />
                      </Box>
                      <Stack direction="row" className="loginContentSub">
                        <h1 className="me-2 animate__animated animate__fadeInUp animate__slow">
                          Welcome to{" "}
                        </h1>
                        <Box className="h2 ml-2 animate__animated animate__jackInTheBox">
                          Inaipi Spark
                        </Box>
                      </Stack>
                      <Box className="loginContentSub_2 animate__animated animate__fadeInUp animate__slow">
                        <p>
                          Your gateway to unlock seamless customer engagement
                          across all channels. Empower your team with a unified
                          platform designed to elevate every customer
                          interaction.
                        </p>
                      </Box>
                      <Box className="LoginForm">
                        <Box component="form" noValidate autoComplete="off">
                          <FormControl
                            sx={{ mb: 2 }}
                            variant="outlined"
                            fullWidth
                            size="small"
                            className="animate__animated animate__fadeInUp animate__slow"
                          >
                            <label
                              for="exampleFormControlInput1"
                              class="form-label"
                            >
                              Username
                            </label>
                            <OutlinedInput
                              fullWidth
                              id="email"
                              type={"text"}
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              placeholder="Enter your username"
                              sx={{ fontSize: "13px" }}
                              autocomplete="off"
                            />
                            {emailval && (
                              <span className="text-danger mt-1 fs-12 d-flex align-items-center">
                                <MdErrorOutline className="me-1" /> Username is
                                Required
                              </span>
                            )}
                          </FormControl>
                          <FormControl
                            sx={{ mb: 2 }}
                            variant="outlined"
                            fullWidth
                            size="small"
                            className="animate__animated animate__fadeInUp animate__slow"
                          >
                            <label for="Password" class="form-label">
                              Password
                            </label>
                            <OutlinedInput
                              sx={{ fontSize: "13px" }}
                              fullWidth
                              placeholder="Enter your password"
                              id="password"
                              type={showPassword ? "password" : "text"}
                              value={pass}
                              onKeyDown={handleKeyPress}
                              onChange={(e) => setPass(e.target.value)}
                              endAdornment={
                                <InputAdornment
                                  position="end"
                                  id="password"
                                  value={pass}
                                  onChange={(e) => setPass(e.target.value)}
                                  onKeyDown={handleKeyPress}
                                >
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    edge="end"
                                    size="small"
                                    onClick={handleClickShowPassword}
                                  >
                                    {showPassword ? <FiEye /> : <FiEyeOff />}
                                  </IconButton>
                                </InputAdornment>
                              }
                              label=""
                            />
                            {passval && (
                              <span className="text-danger mt-1 fs-12 d-flex align-items-center">
                                <MdErrorOutline className="me-1" />
                                Password is Required
                              </span>
                            )}
                          </FormControl>

                          <FormGroup
                            sx={{
                              mb: 2,
                              fontSize: "12px",
                              display: "flex",
                              flexDirection: "row",
                            }}
                            className="animate__animated animate__fadeInUp animate__slow"
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  type="checkbox"
                                  // onChange={handleChange}
                                  // ref={ref}
                                />
                              }
                              label="Remember Me"
                              size="small"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "12px",
                                  color: "#0b3363",
                                },
                              }}
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  type="checkbox"
                                  onChange={(e) => {
                                    if (e.currentTarget.checked) {
                                      props.setWebRTC(true);
                                    } else {
                                      props.setWebRTC(false);
                                    }
                                  }}
                                />
                              }
                              label="SoftPhone"
                              size="small"
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "12px",
                                  color: "#0b3363",
                                },
                              }}
                            />
                          </FormGroup>
                          <Box>
                            <Button
                              className="animate__animated animate__fadeInUp animate__slow"
                              disableElevation
                              variant="contained"
                              fullWidth
                              size="large"
                              sx={{
                                height: "3rem",
                                font: "normal normal bold 16px/25px Poppins",
                                letterSpacing: "1.12px",
                                textShadow: "0px 3px 6px #00000029",
                                textTransform: "capitalize",
                              }}
                              id="connectSocket"
                              onClick={onSubmit}
                            >
                              {spinner ? (
                                <>
                                  <CircularProgress
                                    color="inherit"
                                    size={20}
                                    thickness={2.5}
                                    sx={{ ml: 1 }}
                                  />
                                </>
                              ) : (
                                "Sign in"
                              )}
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                      <footer
                        className="copyrights animate__animated animate__fadeInUp animate__delay-2s"
                        spacing={2}
                      >
                        <Stack direction="row">
                          © 2024
                          <a href="https://www.inaipiapp.com" target="_blank" className="ms-1">
                            inaipi.
                          </a>
                          <Typography className="mx-1"> All rights reserved.</Typography>
                        </Stack>
                      </footer>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                xl={6}
                className="RightMain animate__animated animate__fadeIn animate__slow"
              >
                <Stack>
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box className="LoginImagesMain">
                      <Box className="LoginImagesSub animate__animated animate__fadeIn animate__slow">
                        <img src={rightmainimg} className="mainImage" />
                        <Box className="BoxBorder_2 animate__animated animate__fadeInUp"></Box>
                        <Box className="BoxBorder">
                          <img
                            src={img1}
                            className="image_1 animate__animated animate__pulse animate__infinite animate__delay-1s animate__slower"
                          />
                          <img
                            src={img2}
                            className="image_2 animate__animated animate__pulse animate__infinite animate__delay-2s animate__slower"
                          />
                          <img
                            src={img3}
                            className="image_3 animate__animated animate__pulse animate__infinite animate__delay-3s animate__slower"
                          />
                          <img
                            src={img4}
                            className="image_4 animate__animated animate__pulse animate__infinite animate__delay-4s animate__slower"
                          />
                          <img
                            src={img5}
                            className="image_5 animate__animated animate__pulse animate__infinite animate__delay-5s animate__slower"
                          />
                          <img
                            src={img6}
                            className="image_6 animate__animated animate__pulse animate__infinite animate__delay-6s animate__slower"
                          />
                          <img
                            src={img7}
                            className="image_7 animate__animated animate__pulse animate__infinite animate__delay-7s animate__slower"
                          />
                        </Box>
                      </Box>
                      <Box className="LoginRightContent animate__animated animate__fadeInUp animate__delay-1s animate__slow">
                        <h6 className="anime">
                          ENTER THE FUTURE OF CUSTOMER EXPERIENCE
                        </h6>
                        <p>
                          Empower your agents with an omnichannel platform for
                          seamless CX across all touchpoints.
                        </p>
                      </Box>
                    </Box>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Box>
          {/* New login page end here  */}
        </div>
      )}
      {!showloginPage && (
        <Box
          sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Backdrop sx={{ color: "#fff", zIndex: 1 }} open={true}>
            <CircularProgress />
          </Backdrop>
        </Box>
      )}

      {/* Dialog  already logged in  */}
      <Dialog
        open={logoutModalDialog}
        onClose={LogoutDialogClose}
        sx={{
          "& .MuiPaper-root": {
            padding: 1,
            top: -100,
          },

          backgroundColor: "rgb(0 0 0 / 15%)",
        }}
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 600 }}>
          Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Looks like you're already logged in. Sign out to switch accounts
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              logout();
            }}
          >
            Sign out
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default connect(mapStateToProps, {
  setsidebarVal,
  setReadyButton,
  setShowingStatus,
  setShowingStatusVoice,
  setShowingStatusClass,
  setVoicePlatForm,
  setWebRTC,
})(Login);
